// Languages the pre-signup pages are offered in; the backend register serializer accepts the same set.
const LANGUAGES = [
  { code: 'cs', country: 'CZ', label: 'Čeština' },
  { code: 'sk', country: 'SK', label: 'Slovenčina' },
  { code: 'en', country: 'GB', label: 'English' },
  { code: 'pl', country: 'PL', label: 'Polski' },
  { code: 'hu', country: 'HU', label: 'Magyar' },
  { code: 'ro', country: 'RO', label: 'Română' },
] as const;

const DEFAULT_LANGUAGE = LANGUAGES.find((language) => language.code === 'en')!;

// Auth pages are served under every locale in settings.LANGUAGES; undefined means "not one of ours".
const currentLanguage = () => LANGUAGES.find((language) => language.code === window.appState.lang);

const signupLanguage = () => currentLanguage() || DEFAULT_LANGUAGE;

export { LANGUAGES, DEFAULT_LANGUAGE, currentLanguage, signupLanguage };
